export default __webpack_public_path__ + "static/media/bannerFinanceiro.181c89d2.jpg";